import Utils from '@/ecm/common/Utils'
export default class FlowDiagramTransition {
    constructor (dto, nodes) {
        this.id = null;
        this.type = null;
        this.source = null;
        this.destination = null;

        if (dto) {
            this.id = dto.StateFrom;
            this.type = dto.TransitionType === "V" ? "pass" : "reject";
            this.source = { id: dto.StateFrom, position: 'bottom' }
            this.destination = { id: dto.StateTo, position: 'top'};
        }
    }
}
